module.exports = Object.assign({ jsx: React.createElement, Fragment: React.Fragment }, React);